import * as React from 'react'
import styled from 'styled-components'
import { useDisplayVariant } from 'modules/productDetail'
import config from 'config'
import EnergyLabel from 'theme/atoms/EnergyLabel'

export default function SpecialLabels() {
  const variant = useDisplayVariant()

  return (
    <Wrapper className="SpecialLabels">
      <div className="special-icon">
        {variant.data.attributes?.ENERGY_EFFICIENCY_CLASS && (
          <EnergyLabel
            data-cy-state="show-energy-label"
            energyLabelLink={
              variant.data.attributes.ENERGY_LABEL?.values[0].document || null
            }
            label={
              variant.data.attributes.ENERGY_EFFICIENCY_CLASS?.values[0]
                .value || ''
            }
            size="medium"
          />
        )}
        {variant.data.attributes?.WARRANTY_REPURCHASE &&
          !variant.data.attributes?.ENERGY_EFFICIENCY_CLASS && (
            <Warranty
              data-cy-state={'show-warrantyRepurchase'}
              $imgSrc={
                config.modules.cloudinary.endpoint +
                  variant.data.attributes.WARRANTY_REPURCHASE.values[0].icon ||
                ''
              }
              $title={
                variant.data.attributes.WARRANTY_REPURCHASE.values[0].value +
                ' ' +
                variant.data.attributes.WARRANTY_REPURCHASE.label
              }
            />
          )}
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div``

type WarrantyProps = {
  $title: string
  $imgSrc: string
}
const Warranty = styled.figure.attrs<WarrantyProps>((p) => ({
  title: p.title
}))`
  display: inline-block;
  margin: 0;
  width: 43px;
  height: 43px;
  background-image: url(${(props: WarrantyProps) => props.$imgSrc});
  background-repeat: no-repeat;
  background-size: contain;
`
